import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { listGroups } from '@plone/volto/actions';
import { Link } from 'react-router-dom';
import qs from 'query-string';

const Departments = () => {
  const dispatch = useDispatch();
  const departments = useSelector((state) => state.groups);
  const location = useSelector((state) => state.router?.location);
  const urlDepartment = qs.parse(location?.search).department;

  useEffect(() => {
    dispatch(listGroups());
  }, [dispatch]);

  return (
    <div className="navbar-department-list">
      {departments.groups.map(({ groupname, title, color }, idx) => {
        const departmentName =
          groupname.match(/^department_(\w+)/) != null ? title : null;
        return departmentName != null ? (
          <Link
            className="department"
            data-active={urlDepartment === groupname}
            key={idx}
            to={'/search?department=' + groupname}
          >
            <div
              className="icon"
              style={
                color === 'none' ? undefined : { '--department-color': color }
              }
            >
              {departmentName[0]}
            </div>
            <div className="text">{departmentName}</div>
          </Link>
        ) : null;
      })}
    </div>
  );
};

export default Departments;
